import { FriendsState, FriendsResponse } from "./types";

import { fetchFriends } from "./services";

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: FriendsState = {
    friends: [],
    loading: false,
    error: null,
};

const userFriendsSlice = createSlice({
    name: 'userFriends',
    initialState,
    reducers: {
        resetUserFriendsState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFriends.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFriends.fulfilled, (state, action: PayloadAction<FriendsResponse>) => {
                state.loading = false;
                state.friends = action.payload.response.collection;
            })
            .addCase(fetchFriends.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string || 'Failed to fetch friends';
            });
    },
});

export const userFriendsReducer = userFriendsSlice.reducer;
export const { resetUserFriendsState } = userFriendsSlice.actions;
